export default __webpack_public_path__ + "images/966ab6e470060a0bbf6708f4eabbab45.png";